import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { SupportService } from 'src/app/shared/services/support.service';
import { EmailSupportService } from 'src/app/shared/services/email-support.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { EmailSupportModalComponent } from '../email-support-modal/email-support-modal.component';

type SupportView = 'main' | 'call';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss'],
})
export class SupportModalComponent implements OnInit {
  currentView: SupportView = 'main';
  brandDisplayName = '';
  showEmailSupport = false;

  constructor(
    public dialogRef: MatDialogRef<SupportModalComponent>,
    private localizationService: LocalizationService,
    public supportService: SupportService,
    private emailSupportService: EmailSupportService,
    private helperService: HelperService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.brandDisplayName = this.supportService.getBrandDisplayName();
    this.showEmailSupport = this.emailSupportService.isEmailSupportAvailable();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  showMainView(): void {
    this.currentView = 'main';
  }

  showCallSupport(): void {
    this.currentView = 'call';
  }

  onBack(): void {
    if (this.currentView === 'call') {
      this.showMainView();
      return;
    }
    this.closeDialog();
  }

  openExternalLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openEmailSupport(): void {
    if (!this.showEmailSupport) {
      return;
    }
    this.dialogRef.close();
    this.helperService.openModalDialog(
      EmailSupportModalComponent,
      null,
      [CONSTANTS.EMAIL_SUPPORT_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }
}
